import React from 'react';
import './MissingServiceFallback.css';

const MissingServiceFallback: React.FC = () => {
  return (
    <div className="missing-service-container">
      <div className="missing-service-card">
        <h1 className="fallback-title">Service Not Available</h1>
        <p className="fallback-subtitle">
          Please select a valid service to view the dashboard.
        </p>
        <p className="fallback-message">
          The service you’re trying to access isn’t configured or might be unavailable.
        </p>
      </div>
    </div>
  );
};

export default MissingServiceFallback;
